import { render, staticRenderFns } from "./OtherFeatures.vue?vue&type=template&id=b5c49898"
import script from "./OtherFeatures.vue?vue&type=script&lang=js"
export * from "./OtherFeatures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports